import React, { FC } from 'react';
import { ActivityIndicator, Icon, IconButton, Tooltip } from '@kontentino/ui';
import clsx from 'clsx';
import { PostCommunicationContent } from 'app/modules/posts/modules/post/components/postCommunication/types/postCommunicationContent';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import { useTranslation } from 'react-i18next';
import { usePostCommunicationContext } from 'app/modules/posts/modules/post/components/postCommunication/PostCommunicationProvider';
type Props = {
  value: string;
  activeContent: PostCommunicationContent;
  isLoading: boolean;
  onSubmit: () => void;
  disabled?: boolean;
};

const CommentsTextEditorSubmitButton: FC<Props> = ({
  value,
  onSubmit,
  isLoading,
  activeContent,
  disabled,
}) => {
  const { t } = useTranslation();
  const { user: currentUser } = usePostCommunicationContext();

  const hasValidValue = value.trim();

  return (
    <Tooltip
      content={!hasValidValue ? t('validation.addCommentText') : undefined}
    >
      <div>
        <IconButton
          variant="primary"
          className={clsx('tw-shrink-0 tw-rounded-full', {
            'tw-bg-purple-100 hover:tw-bg-purple-120':
              activeContent === PostCommunicationContent.CLIENT &&
              currentUser.role !== 'client',
          })}
          size="medium"
          disabled={disabled}
          onClick={!isLoading ? onSubmit : undefined}
          data-name="comments-text-editor-submit"
          data-cy="comments-text-editor-submit"
        >
          {isLoading ? <ActivityIndicator /> : <Icon icon={faArrowUp} />}
        </IconButton>
      </div>
    </Tooltip>
  );
};

export default CommentsTextEditorSubmitButton;
